import api from "../apiClient";

// SINGLE source of truth for the assistant endpoint (crm_backend: api/assistant/*).
// Rule: any fetch/axios call in this app imports from an endpoints module —
// hand-built URLs fail review (a divergent path shipped twice from exactly that).
export const ORCHESTRATE_ENDPOINT = "/assistant/orchestrate/";

// A chat call that hangs with no error is never acceptable: every orchestrate
// call carries a hard timeout so the UI can render a designed failure state.
export const ASSISTANT_TIMEOUT_MS = 30000;

export const orchestrateAssistant = async (payload = {}) => {
  const response = await api.post(ORCHESTRATE_ENDPOINT, payload, {
    timeout: ASSISTANT_TIMEOUT_MS,
  });
  return response?.data || {};
};

const assistantApi = {
  orchestrateAssistant,
};

export default assistantApi;
